




















































































import { Component, Vue } from "vue-property-decorator";
import { PayPackage } from "@/common/entity/PayPackage";
import { User } from "@/common/entity/User";
import { UiTools } from "@/common/UiTools";
import QRCode from "qrcode";
import { Message } from "element-ui";
import { IWxOrder, WxOrder } from "@/common/entity/WxOrder";
import { appEnv } from "@/common/AppConst";
import { RouterTools } from "@/common/RouterTools";
import { RootMutationNames, RootState } from "@/vuex-store";
import { OtherApi } from "@/request/other";
import { Response } from "@/common/entity/Response";
import { WechatApi } from "@/request/wechat";
import { AppConfigs } from "@/common/entity/AppConfigs";
import { AliPayApi } from "@/request/alipay";
import { logError, logToConsole } from "@/common/LogHelper";
import { PayOrder } from "@/common/entity/PayOrder";
import { PayOrderApi } from "@/request/pay-order";
import { UserApi } from "@/request/user";

const DURATION_QUERY_ORDER_MS = 1000;
const PAY_RETURN_PATH = "/pay/return";

@Component
export default class Pay extends Vue {
    readonly payingDialogWidth = 400;
    readonly qrCodeCanvasId = "qr-code-canvas";
    readonly refNames = {
        qrCode: "qrCode",
    };

    payPkgs: PayPackage[] = [];
    id: number | null = null;
    payingPkg: PayPackage | null = null;
    isPaying: boolean = false;
    qrCodeTip: string = "";
    showPayWayDialog: boolean = false;
    showWxPayDialog: boolean = false;
    queryingAliOrder: boolean = false;

    get qrCodeSize(): number {
        return this.payingDialogWidth / 2;
    }

    get payingPkgName(): string {
        return this.payingPkg?.name || "";
    }

    get payingCount(): string {
        return this.payingPkg?.count + "次" || "";
    }

    get payingFee(): number {
        return (this.payingPkg?.fee || 0) / 100;
    }

    get userInfo(): User | null {
        return (this.$store.state as RootState).currUser;
    }

    get isLogin(): boolean {
        return !!this.userInfo;
    }

    get qrCode() {
        return this.$refs[this.refNames.qrCode];
    }

    get apiConfigs(): AppConfigs | null {
        return (this.$store.state as RootState).appConfigs;
    }

    created() {
        // 获取支付套餐列表
        this.reqPayPkgs();

        // 获取query参数outTradeNo，并查询支付宝订单状态
        logToConsole("支付界面query参数", this.$route.query);
        const outTradeNo = this.$route.query.out_trade_no;
        if (!outTradeNo || typeof outTradeNo !== "string") return;
        this.queryAliOrder(outTradeNo);
    }

    deactivated() {
        this.payingPkg = null;
    }

    /**
     * 点击支付按钮
     */
    clickPayBtn(pkg: PayPackage) {
        // 检查是否登录
        if (!this.isLogin) {
            UiTools.toLogin();
            return;
        }

        // 显示扫码提示框，并设置显示的套餐支付信息
        this.payingPkg = pkg;
        this.showPayWayDialog = true;
    }

    /**
     * 点击支付宝支付按钮
     */
    async clickAliPayBtn() {
        if (!this.payingPkg) return;
        AliPayApi.sendPayForm(
            this.payingPkg.id,
            appEnv.localUrl + PAY_RETURN_PATH
        );
    }

    /**
     * 点击微信支付按钮
     */
    clickWxPayBtn() {
        this.showPayWayDialog = false;
        this.showWxPayDialog = true;
    }

    /**
     * 扫描提示框显示时调用
     */
    async onPayDialogOpened() {
        if (!this.payingPkg) return;
        this.qrCodeTip = "生成二维码中...";
        try {
            const wxOrder: IWxOrder = await WechatApi.payQrCode(
                this.payingPkg.id
            );
            QRCode.toCanvas(
                this.qrCode,
                wxOrder.qrCodeUrl,
                { errorCorrectionLevel: "H", width: this.qrCodeSize },
                (error: any) => {
                    if (error) this.qrCodeTip = this.handleQrCodeErr(error);
                    else {
                        this.qrCodeTip = "";
                        this.queryOrder(wxOrder.id);
                    }
                }
            );
        } catch (error) {
            this.qrCodeTip = this.handleQrCodeErr(error);
        }
    }

    /**
     * 查询微信订单
     */
    async queryOrder(orderId: number) {
        const userOrder = await WechatApi.queryOrder(orderId, false);
        const order = new WxOrder(userOrder.order);
        switch (order.tradeState) {
            case "SUCCESS":
                if (userOrder.user)
                    this.$store.commit(
                        RootMutationNames.setCurrUser,
                        userOrder.user
                    );
                this.isPaying = false;
                this.payingPkg = null;
                Message.success({
                    message: order.tradeStateText,
                    showClose: true,
                });
                this.$router.push(RouterTools.pageNames.writing);
                return;
            case "PAYERROR":
                this.isPaying = false;
                this.payingPkg = null;
                Message.error({
                    message: order.tradeStateText,
                    showClose: true,
                    duration: 0,
                });
                return;
            case "REFUND":
            case "CLOSED":
                this.isPaying = false;
                this.payingPkg = null;
                Message.warning({
                    message: order.tradeStateText,
                    showClose: true,
                    duration: 0,
                });
                return;
            case "USERPAYING":
                this.isPaying = true;
                setTimeout(() => {
                    this.queryOrder(orderId);
                }, DURATION_QUERY_ORDER_MS);
                return;
            case "NOTPAY":
                if (!this.payingPkg) return;
                setTimeout(() => {
                    this.queryOrder(orderId);
                }, DURATION_QUERY_ORDER_MS);
                return;
            case "REVOKED":
                this.payingPkg = null;
                return;
            default:
                this.isPaying = false;
                this.payingPkg = null;
                Message.error({
                    message:
                        "订单查询异常，可稍后刷新界面检查是否购买成功，如有问题可联系客服",
                    showClose: true,
                    duration: 0,
                });
        }
    }

    /**
     * 处理生成和扫描失败的错误
     * @returns 提示给用户的信息
     */
    handleQrCodeErr(error: any): string {
        return error instanceof Response
            ? error.userMsg
            : appEnv.isProd
            ? Response.MSG_APP_EXCEPTION
            : JSON.stringify(error);
    }

    /**
     * 扫描提示框关闭时调用
     */
    onPayDialogClosed() {
        this.payingPkg = null;
    }

    /**
     * 请求支付套餐列表
     */
    async reqPayPkgs() {
        this.payPkgs = (await OtherApi.payPkgs()).map((pkg) => {
            return new PayPackage(pkg);
        });
    }

    /**
     * 查询支付宝支付订单状态
     */
    async queryAliOrder(outTradeNo: string) {
        this.queryingAliOrder = true;
        try {
            const response = await PayOrderApi.aliOrder(outTradeNo);
            const order: PayOrder = new PayOrder(response.order);

            // 支付中
            if (order.isPaying) {
                setTimeout(() => {
                    this.queryAliOrder(outTradeNo);
                }, DURATION_QUERY_ORDER_MS);
                return;
            }

            // 支付成功
            if (order.isPaid) {
                // 获取最新用户信息
                const user = await UserApi.reqUserInfo(false);
                this.$store.commit(RootMutationNames.setCurrUser, user);

                // 提示支付成功
                this.queryingAliOrder = false;
                Message.success("支付成功");
                RouterTools.pushTo("writing");
                return;
            }

            // 支付失败
            if (order.isPayFail) {
                this.queryingAliOrder = false;
                Message.error("支付失败，如有问题可联系客服");
                return;
            }

            // 异常
            logError("订单状态异常，order=", order);
            this.queryingAliOrder = false;
            if (order.exection_msg) {
                Message.error({
                    message:
                        "订单异常，可稍后刷新界面检查是否购买成功，如有问题可联系客服",
                    duration: 0,
                });
            }
        } catch (error) {
            this.queryingAliOrder = false;
        }
    }
}
